import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef } from 'react';

function IconComponent(_a, ref) {
  var {
      id,
      fontSize = 'small',
      className,
      name,
      color
    } = _a,
    rest = __rest(_a, ["id", "fontSize", "className", "name", "color"]);
  const classNames = clsx('guardian-icon', 'guardian-icon--' + fontSize, className);
  return jsx("span", Object.assign({
    ref: ref,
    id: id,
    style: {
      color
    },
    className: classNames
  }, rest, {
    children: name
  }));
}
const Icon = /*#__PURE__*/forwardRef(IconComponent);

export { Icon };
